/**
 * Brightness Style03 - 垂直：縱向滑桿 + 燈泡圖示
 * 黃色填充、無桿子、燈泡在底部
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import './BrightnessStyle03.css'

export function BrightnessStyle03({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const currentBrightness = (state?.brightness as number) ?? 100
  const [brightness, setBrightness] = useState(currentBrightness)
  useEffect(() => {
    setBrightness((state?.brightness as number) ?? 100)
  }, [state?.brightness])

  const handleChange = (value: number) => {
    setBrightness(value)
    void onCommand('setBrightness', { brightness: value })
  }

  return (
    <div className="trait-brightness-style03">
      <div
        className="trait-brightness-style03__track-wrap"
        style={{
          background: `linear-gradient(to top, #facc15 0%, #facc15 ${brightness}%, rgba(255,255,255,0.12) ${brightness}%, rgba(255,255,255,0.12) 100%)`,
        }}
      >
        <span className="material-symbols-rounded trait-brightness-style03__icon">lightbulb</span>
        <input
          type="range"
          min={0}
          max={100}
          value={brightness}
          onChange={(e) => setBrightness(Number(e.target.value))}
          onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
          onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
          className="trait-brightness-style03__range"
          disabled={disabled}
        />
      </div>
    </div>
  )
}
